<style scoped>
select.missingSelection {
  border: 1px solid red;
}
</style>
<script>
import axios from "axios";
import { debounce } from "../utils/debounce";
import { createElementFromHTML } from "../utils/common";
import getParameter from "get-parameter";

let filterApi = '';
let searchApi = '';

function pushDataLayer(obj) {
  if (window.dataLayer && obj) {
    window.dataLayer.push(obj);
  } else {
    console.log("FindARep: Warning: no dataLayer");
  }
}

function getSelectText(el) {
  if (el && el.options && el.selectedIndex >= 0) {
    return el.options[el.selectedIndex].text;
  } else {
    return el.value ?? "";
  }
}

function getMatchText(collection, key, defaultValue) {
  if (collection && collection.find) {
    return collection.find(x => x.k == key)?.t ?? defaultValue;
  }
  return defaultValue;
}

export default {
  name: 'FindARep',
  data() {
    return {

      filterModel: {},

      states: [],
      markets: [],
      counties: [],
      states: [],
      countries: [],
      selectedCountry: 0,
      selectedState: 0,
      selectedCounty: 0,
      selectedMarket: 0,

      initialized: false,
      loading: false,
      lastFocusable: null,

      resultsVisible: false,
      showErrors: false,

      results: []
    };
  },
  props: {
    dataUrl: String,
    dataFormUrl: String,
    forceMarket: String,
    defaultCountry: String,
    internationalMode: String,
    internationalRep: Object,
    suppressScroll: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    noResults: function () {
      if (this.results.length) {
        return false;
      } else {
        return true;
      }
    },
    isInternational:function(){
      if(this.internationalMode && this.internationalMode.toLowerCase()=="true"){
        return true;
      }

      return false;
    },
    isInternationalCountrySelected:function(){
      if(this.isInternational){
        let selectedLabel = getMatchText(this.countries, this.selectedCountry);
        if(selectedLabel != "Canada" && selectedLabel!="United States"){
          return true;
        }
      }
      return false;
    }
  },
  async mounted() {
    this.selectedMarket = this.forceMarket ?? 0;
    this.selectedCountry = this.defaultCountry ?? 0;

    filterApi = `${this.dataUrl}/all-filters${this.isInternational?"?international=true":""}`;
    searchApi = `${this.dataUrl}/search`;

    await this.loadFilterModel();
    this.refreshDropDowns("country");



  },
  created() {
    axios.interceptors.request.use(
      (config) => {
        // trigger 'loading=true' event here
        this.loading = true;
        return config;
      },
      (error) => {
        // trigger 'loading=false' event here
        this.loading = false;
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      (response) => {
        this.loading = false;
        return response;
      },
      (error) => {
        this.loading = false;
        return Promise.reject(error);
      }
    );
  },
  methods: {

    async loadFilterModel() {

      try {
        const model = await axios.get(filterApi);
        this.filterModel = model.data;
        this.countries = model.data.Countries;
        this.markets = model.data.Markets;
      } catch (e) {
        console.log(`Failed to load filters: ${e}`);
        this.resultsVisible = true;
        this.results = [];
      }

    },
    async search() {
      this.showErrors = true;

      if(!this.isInternationalCountrySelected){
        //only show results if there is a selected county
        if (this.selectedCounty && (this.selectedMarket || this.selectedCountry == 'Canada')) {

          try {
            const result = await axios.post(searchApi, {
              country: this.selectedCountry,
              state: this.selectedState,
              county: this.selectedCounty,
              market: this.selectedCountry == 'Canada' ? "ResidentialCommercial" :  this.selectedMarket
            });

            this.results = result.data ?? [];

          } catch (e) {
            this.results = [];
            console.log(`Failed to search: ${e}`);
          }

          this.resultsVisible = true;

        }
      } else {
        //in international mode, we just present a preconfigured person regardless of what they select
        console.log(this.internationalRep);
        
        if(this.internationalRep && this.internationalRep.Id){
          this.results = [this.internationalRep];
        } else {
          this.results = [];
        }

        this.resultsVisible=true;

      }
    },
    refreshDropDowns(change) {
      this.showErrors = false;
      this.resultsVisible = false;


      if (change == "country" && this.selectedCountry) {
        this.selectedState = 0;
        this.selectedCounty = 0;
        this.states = this.filterModel.Countries.find(x => x.k == this.selectedCountry)?.States ?? [];
        this.counties = [];
      } else if (change == "state" && this.selectedCountry && this.selectedState) {
        this.selectedCounty = 0;
        this.counties = this.filterModel.Countries.find(x => x.k == this.selectedCountry)?.States?.find(x => x.k == this.selectedState)?.Counties ?? [];
      } else if (change == "reset") {
        this.selectedCountry = this.defaultCountry ?? 0;
        this.selectedMarket =  this.forceMarket ?? 0;
        this.selectedState = 0;
        this.selectedCounty = 0;
        this.states = [];
        this.counties = [];
      }


    },
    onChangeCountry(event) {
      this.initialized = true;
      this.refreshDropDowns("country");
      pushDataLayer({
        event: "filter",
        filter_type: "Country",
        selection: getSelectText(event.target),
      });

    },
    onChangeState(event) {
      this.initialized = true;
      this.refreshDropDowns("state");
      pushDataLayer({
        event: "filter",
        filter_type: "State",
        selection: getSelectText(event.target),
      });
    },
    onChangeCounty(event) {
      this.initialized = true;
      this.refreshDropDowns("county");
      pushDataLayer({
        event: "filter",
        filter_type: "County",
        selection: getSelectText(event.target),
      });
    },
    onChangeMarket(event) {
      this.initialized = true;
      this.refreshDropDowns("market");
      pushDataLayer({
        event: "filter",
        filter_type: "Market",
        selection: getSelectText(event.target),
      });
    },
    resetFilters(event) {

      this.refreshDropDowns("reset");

      if (this.defaultCountry) {
        this.selectedCountry = this.defaultCountry;
        this.refreshDropDowns("country");
      }

      //show default state of widget
      this.initialized = false;

    },
    selectRep(result) {
      localStorage.selectedRepName = result.Name;

      if (result.PhotoUrl) {
        localStorage.selectedRepImage = result.PhotoUrl;
      } else {
        localStorage.selectedRepImage =
          "/assets/toolkit/images/placeholder-profile.png";
      }

      localStorage.selectedRepId = result.Id;

      let market = "Residential/Commercial";
      if(this.selectedCountry == "United States" && this.selectedMarket) {
        market = getMatchText(this.markets, this.selectedMarket) ?? market;
      }

      //data for adsform
      localStorage.selectedRepFormFields = JSON.stringify(
        {
          rep_name: result.Name,
          salesforce_userid: result.Id,
          country: getMatchText(this.countries, this.selectedCountry),
          state: getMatchText(this.states, this.selectedState),
          county: this.selectedCounty==0?undefined:this.selectedCounty, //we keep the original county name with full captials to match how it worked before
          market: market,
          project_type: market
        });

      //console.log(localStorage.selectedRepFormFields, localStorage.selectedRepName, localStorage.selectedRepId);
      window.location.href = this.$props.dataFormUrl;

    },
  },
};
</script>